<!-- start page title -->
<div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
                <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/">Accueil</a>
                    </li>
                    <ng-container *ngFor="let item of breadcrumbItems">
                        <li class="breadcrumb-item" *ngIf="!item.active"><a href="javascript: void(0);" routerLink="[item.path]">{{item.label}}</a>
                        </li>
                        <li class="breadcrumb-item active" *ngIf="item.active"><a routerLink="[item.path]">{{item.label}}</a></li>
                    </ng-container>
                </ol>
            </div>
            <h4 class="page-title">{{title}}
            </h4>
            <!-- <p *ngIf="menuSemaineAlert == 'notFound'">
                <ngb-alert type="info" [dismissible]="false">
                    <strong>Veuillez créer un programme pour le menu de la semaine -</strong> 
                    Aucun programme enrégistré pour cette semaine!</ngb-alert>
                </p>
            <p *ngIf="menuSemaineAlert == 'notCompleted'">
                <ngb-alert type="info" [dismissible]="false">
                    <strong>Veuillez complèter le programme pour le menu de la semaine -</strong> 
                    Le programme des menus de la semaine est incomplet!</ngb-alert>
                </p> -->
            
        </div>
    </div>
</div>
<!-- end page title -->